import React from 'react'
import { Message } from './Message/Message'
import IMessage from 'models/Message'

export interface MessageListProps {
  header: React.ReactNode
  headerAction?: React.ReactNode
  messages: IMessage[]
  emptyText: string
  className?: string
  selectedMessageId?: string
  messageType: string
  isInsideOfModal: boolean
}

export const MessageList: React.FC<MessageListProps> = ({ messageType, selectedMessageId, className = '', header, headerAction, messages, emptyText, isInsideOfModal }) => (
  <div className={`${className}`}>
    <h2 className='ch-c-message-list__header'>
      {header}{headerAction}
    </h2>
    <ul className='ch-u-list-style-type--none ch-u-message-list-ul'>
      {messages.length
        ? messages.map((message) =>
          <li key={message.guid}>
            <Message
              selectedMessageId={selectedMessageId}
              messageType={messageType}
              message={message}
              key={message.guid}
              isInsideOfModal={isInsideOfModal}
            />
          </li>)
        : <div className='ch-c-message__empty-text'>{emptyText}</div>}
    </ul>
  </div>
)
